/** Brief lock so URL/thread sync cannot cancel an in-flight Shell <Link>. */

let lockedUntil = 0

export function lockLeafNavigation(ms = 2_000): void {
  lockedUntil = Date.now() + ms
}

export function isLeafNavigationLocked(): boolean {
  return Date.now() < lockedUntil
}

/** True when the in-flight leaf URL (path + agent) is visible in the address bar. */
export function leafHrefCommitted(
  href: string,
  current: Pick<Location, 'pathname' | 'search' | 'origin'> = window.location,
): boolean {
  const target = new URL(href, current.origin)
  if (current.pathname !== target.pathname) {
    return false
  }
  const targetAgent =
    target.searchParams.get('agentId') || target.searchParams.get('deploymentId')
  if (!targetAgent) {
    return true
  }
  const here = new URLSearchParams(current.search)
  const hereAgent = here.get('agentId') || here.get('deploymentId')
  return hereAgent === targetAgent
}
